import ConfirmModal from "../components/molecules/ConfirmModal"
import AlertModal from "../components/molecules/AlertModal"
import i18n from '../i18n'

const mixin = {
  install: function (Vue) {
     Vue.mixin({
       methods: {
         $confirm: ({message, success, failure}) => {
           const Confirm = Vue.extend(ConfirmModal)
           return new Confirm({
             propsData: {
               message,
               success: success,
               failure: failure,
             },
             i18n
           })
         },
         $alert: ({message, success}) => {
           const Alert = Vue.extend(AlertModal)
           return new Alert({
             propsData: {
               message,
               success: success
             },
           })
         }
       }
     })
  }
}

export default mixin
